import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    flowData: [
      { flowId: 1, flowName: "立项申请" },
      { flowId: 2, flowName: "招待费报备" },
      { flowId: 3, flowName: "外出申请" },
      { flowId: 4, flowName: "请假申请" },
      { flowId: 5, flowName: "付款申请单" },
      { flowId: 6, flowName: "费用报销申请" },
      { flowId: 7, flowName: "用章申请" },
      { flowId: 8, flowName: "回款申请" },
      { flowId: 9, flowName: "实施文档归档申请" },
      { flowId: 10, flowName: "合同归档申请" },
      { flowId: 11, flowName: "协同办公申请" },
      { flowId: 12, flowName: "项目变更申请" },
      { flowId: 13, flowName: "采购申请" },
      { flowId: 14, flowName: "考勤申述" },
      { flowId: 15, flowName: "发票开具申请" },
      { flowId: 16, flowName: "项目交付申请" },
      { flowId: 17, flowName: "备用金申请" },
    ],
    userName: "",
    routeList: [],
    routeMap: {},
  },
  mutations: {
    login(state, userName) {
      state.userName = userName || "新用户";
    },
    setFlowData(state, flowData) {
      state.flowData = flowData || [];
    },
    setRoute(state, path) {
      const index = state.routeMap[path.path];
      if (index != null) {
        state.routeList = state.routeList.slice(0, index + 1);
        state.routeMap = {};
        for (let i = 0; i < state.routeList.length; i++) {
          state.routeMap[state.routeList[i].path] = i;
        }
      } else {
        if (state.routeList.length === 4) {
          state.routeList.pop();
        }
        state.routeList.push(path);
        state.routeMap[path.path] = state.routeList.length - 1;
      }
    },
    resetRoute(state) {
      state.routeList = [];
      state.routeMap = {};
    },
  },
});
export default store;
